export const SCM_SIGN_IN_PURPOSES = {
  POLICY_EXCEPTION: "policy_exception"
} as const

export const SCM_SIGN_IN_ERROR_REASONS = [
  "NOT_FOUND",
  "INVALID_REQUEST",
  "INVALID_STATE",
  "SCM_NOT_SUPPORTED",
  "SCM_NOT_CONNECTED",
  "SIGN_IN_NOT_CONFIGURED",
  "NO_ACCESS",
  "NO_VERIFIED_EMAIL",
  "TRY_AGAIN"
] as const
